export function formatNumberOfGuests(numberOfGuests: number, upperFirstLetter = false) {
    const key = upperFirstLetter ? "Guest" : "guest";
    const numberOfGuestsFormatted =
        typeof numberOfGuests === "number"
            ? `${numberOfGuests > 1 ? `${numberOfGuests} ${key}s` : `${numberOfGuests} ${key}`}`
            : "#";
    return numberOfGuestsFormatted;
}

export function formatNumberOfPets(numberOfPets: number | undefined, upperFirstLetter = false) {
    const key = upperFirstLetter ? "Pet" : "pet";
    const numberOfPetsFormatted =
        typeof numberOfPets === "number"
            ? `${numberOfPets > 1 ? `${numberOfPets} ${key}s` : `${numberOfPets} ${key}`}`
            : "#";
    return numberOfPetsFormatted;
}
export function formatNights(nights: number | undefined, upperFirstLetter = false) {
    const key = upperFirstLetter ? "Night" : "night";
    const nightsFormatted =
        typeof nights === "number"
            ? `${nights > 1 ? `${nights} ${key}s` : `${nights} ${key}`}`
            : "#";
    return nightsFormatted;
}
